<template>
  <Layout>
    <PageHeader :items="items" :title="title" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4 form-group">
                <label>FROM</label>
                <input
                  v-model="filterreport.date1"
                  type="date"
                  class="form-control m-1"
                  @change="filterReportFunc()"
                />
              </div>
              <div class="col-md-4 form-group">
                <label>TO</label>
                <input
                  v-model="filterreport.date2"
                  type="date"
                  class="form-control m-1"
                  @change="filterReportFunc()"/>
              </div>
              <div class="col-md-4 form-group">
                <label>STAFF</label>
                <model-list-select
                  @input="filterReportFunc()"
                  :list="CLINIC_USERS ? CLINIC_USERS : []"
                  v-model="filterreport.staff"
                  option-value="id"
                  option-text="name"
                  placeholder="select Staff"
                >
                </model-list-select>
              </div>
            </div>

            <!-- Table -->
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      v-model="perPage"
                      :options="pageOptions"
                      class="form-select form-select-sm"
                      size="sm"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>

              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      class="form-control form-control-sm ms-2"
                      placeholder="Search..."
                      type="search"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                :current-page="currentPage"
                :fields="fields"
                :filter="filter"
                :filter-included-fields="filterOn"
                :items="filtered_array"
                :per-page="perPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                bordered
                class="datatables"
                responsive="sm"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>

                <template #cell(amount)="data">
                  {{ thousandSeperator(data.item.itemPrice) }}
                </template>
              </b-table>
              <h3 v-if="!filtered_array" class="text-primary text-center">
                <b-spinner class="m-0" role="status" variant="primary"></b-spinner>
                Please wait...
              </h3>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import moment from "moment";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";

import { mapGetters, mapActions } from "vuex";

export default {
  page: {
    title: "DISPENSED REPORT",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },

  components: {
    Layout,
    PageHeader,
    ModelListSelect,
  },

  data() {
    return {
      filtered_array: [],
      filterreport: {
        date1: "",
        date2: moment(new Date()).format("YYYY-MM-DD"),
        staff: "",
      },
      title: "Dispensed Report",
      items: [
        {
          text: "Dispensed Report",
          href: "#",
        },
        {
          text: "Clients",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 15,
      pageOptions: [15, 25, 50, 100, 250, 500, 1000],
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: true,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "patient.patient_name",
          sortable: true,
          label: "PATIENT NAME",
        },
        {
          key: "patient.patient_code",
          sortable: true,
          label: "PATIENT CODE",
        },
        {
          key: "item.drug",
          sortable: true,
          label: "DRUG",
        },
        {
          key: "dispensed",
          sortable: true,
          label: "DISPENSED",
        },
        {
          key: "amount",
          sortable: true,
          label: "AMOUNT",
        },
        {
          key: "staff",
          sortable: true,
          label: "STAFF",
        },
        {
          key: "dateCreated",
          sortable: true,
          label: "DATE AND TIME",
        },
      ],
    };
  },

  computed: {
    ...mapGetters("pharmacy", ["PharmacyItems"]),
    ...mapGetters("reports", ["DispensedReport"]),
    ...mapGetters("staffModule", ["clinic_staff"]),
    ...mapGetters("users", ["CLINIC_USERS"]),
    rows() {
      return this.filtered_array ? this.filtered_array.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.filtered_array ? this.filtered_array.length : 1;
  },
  watch: {
    DispensedReport(newValue) {
      if (newValue) {
        this.assiginData();
      }
    },
  },
  methods: {
    ...mapActions({
      FetchDispensedReport: "reports/fetchDispensedReport",
      FetchPharmacyItems: "pharmacy/fetchPharmacyItems",
      FetchUsers: "users/fetchUsers",
    }),

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    // COMMA SEPERTOR FUNCTION
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    // END COMMA SEPERATOR

    assiginData() {
      this.filtered_array = this.DispensedReport;
    },
    filterReportFunc() {
      let date1 = this.filterreport.date1;
      let date2 = this.filterreport.date2;
      let staff = this.filterreport.staff;
      this.filtered_array = this.DispensedReport.filter((element) => {
        if (date1 == "" && date2 != "" && staff != "") {
          return element.filter_date <= date2;
        } else if (date1 != "" && date2 == "" && staff == "") {
          return element.filter_date >= date1 && element.staff_id == staff;
        } else if (date1 == "" && date2 != "" && staff != "") {
          return element.filter_date <= date2 && element.staff_id == staff;
        } else if (date1 != "" && date2 != "" && staff != "") {
          return (
            element.filter_date >= date1 &&
            element.filter_date <= date2 &&
            element.staff_id == staff
          );
        } else if (date1 != "" && date2 != "" && staff == "") {
          return element.filter_date >= date1 && element.filter_date <= date2;
        } else {
          this.filtered_array = this.DispensedReport;
        }
      });
    },
  },

  created() {
    this.assiginData();
    this.FetchUsers();
    this.FetchDispensedReport();
    this.FetchPharmacyItems();
  },
};
</script>

<style lang="css" scoped></style>
